module.exports = __webpack_public_path__ + "img/Small-Bevel-Attachment-41.bd82aab2.png";